(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require('groupon-gig/src/gig');



},{"groupon-gig/src/gig":9}],2:[function(require,module,exports){
var Forms, TEXT_INPUTS,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

TEXT_INPUTS = ['date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week'];

Forms = {
  addError: function(errorMessage, field) {
    var $errors, $field, $label, $parent, errorString, formV2_1Selector, isDropdownField, isFormV2_1, isGIGField;
    $field = $(field);
    isGIGField = $field.hasClass('gig-field') || $field.hasClass('gig-field-dropdown');
    formV2_1Selector = '.form-v2-1';
    isFormV2_1 = $field.closest(formV2_1Selector).length > 0;
    if (isGIGField) {
      $label = $field.find('label');
    } else {
      $parent = $field.parent();
      if ($parent.hasClass('gig-field') || $parent.hasClass('gig-field-dropdown')) {
        isGIGField = true;
        $field = $parent;
        $label = $parent.find('label');
      } else {
        $label = $field.siblings("label[for='" + ($field.attr('id')) + "']");
        if (!$label.length) {
          $label = $field.closest('label');
        }
      }
    }
    $field.removeClass('success');
    $errors = $label.find('.error-message');
    if ($field.hasClass('gig-field-dropdown') || $field.prop('tagName').toUpperCase() === 'SELECT') {
      errorString = "<br />" + errorMessage;
      isDropdownField = true;
    } else if ($field.is(':checkbox') && isFormV2_1) {
      errorString = "<br />" + errorMessage;
    } else {
      errorString = errorMessage;
    }
    if ($errors.length) {
      $errors.html(errorString);
    } else {
      $field.addClass('error');
      if (isFormV2_1) {
        $label.append("<span class='error-message'>" + errorString + "</span>");
      } else {
        $label.append("<span class='error-message'><span class='colon'>: </span>" + errorString + "</span>");
      }
    }
    if (isGIGField && !isDropdownField) {
      return GIG.Forms.helpers.fixLabel($label, $field);
    } else {
      return $label.addClass('error');
    }
  },
  disableField: function(field) {
    var $field, $parent, isGIGField;
    $field = $(field);
    isGIGField = $field.hasClass('gig-field') || $field.hasClass('gig-field-dropdown');
    if (!isGIGField) {
      $parent = $field.parent();
      if ($parent.hasClass('gig-field') || $parent.hasClass('gig-field-dropdown')) {
        isGIGField = true;
        $field = $parent;
      }
    }
    if (isGIGField) {
      return $field.addClass('disabled').find('input, select, textarea').attr('disabled', true);
    } else {
      return $field.attr('disabled', true).closest('label').addClass('disabled');
    }
  },
  enableField: function(field) {
    var $field, $parent, isGIGField;
    $field = $(field);
    isGIGField = $field.hasClass('gig-field') || $field.hasClass('gig-field-dropdown');
    if (!isGIGField) {
      $parent = $field.parent();
      if ($parent.hasClass('gig-field') || $parent.hasClass('gig-field-dropdown')) {
        isGIGField = true;
        $field = $parent;
      }
    }
    if (isGIGField) {
      return $field.removeClass('disabled').find('input, select, textarea').removeAttr('disabled');
    } else {
      return $field.removeAttr('disabled').closest('label').removeClass('disabled');
    }
  },
  helpers: {
    fieldClick: function(e) {
      var $field, $input, ref, ref1;
      if ((ref = e != null ? (ref1 = e.target) != null ? ref1.tagName.toUpperCase() : void 0 : void 0) === 'INPUT' || ref === 'TEXTAREA') {
        return;
      }
      $field = $(this);
      $input = $field.find('input, textarea');
      return $input.focus();
    },
    fixLabel: function(label, field) {
      var $field, $label, formV2_1Selector, isFormV2_1, labelMargin, topMargin, translateValue;
      $label = $(label);
      $field = field != null ? $(field) : $label.parents('label');
      formV2_1Selector = '.form-v2-1';
      isFormV2_1 = $field.closest(formV2_1Selector).length > 0;
      if (isFormV2_1) {
        return;
      }
      $label.css('height', '');
      labelMargin = $label.height();
      topMargin = $field.css('margin-top').replace('px', '');
      if (labelMargin >= topMargin) {
        $field.css('margin-top', labelMargin);
      } else if (labelMargin === 0) {
        return setTimeout(function() {
          return GIG.Forms.helpers.fixLabel(label, field);
        }, 1);
      } else {
        $field.css('margin-top', '');
      }
      translateValue = "translateY(-" + labelMargin + "px)";
      return $label.css({
        height: 0,
        transform: translateValue
      });
    },
    inputBlur: function() {
      var $field, $input;
      $input = $(this);
      $field = $input.parents('.gig-field');
      if ($input.val()) {
        $field.addClass('filled');
      } else if (!$field.hasClass('error')) {
        $field.removeClass('filled').css('margin-top', '').find('label').css({
          height: '',
          transform: ''
        });
      }
      return $field.removeClass('focused');
    },
    inputFocus: function() {
      var $field, $input, $label;
      $input = $(this);
      $field = $input.parents('.gig-field');
      $field.addClass('focused');
      if (!$field.hasClass('filled')) {
        $label = $field.find('label');
        return GIG.Forms.helpers.fixLabel($label, $field);
      }
    }
  },
  init: function($el) {
    if ($el == null) {
      $el = $(document.body);
    }
    return this.reloadBindings($el, true);
  },

  /*
   * Fill form elements
   *
   * @param {Object} data         - Object of key value pairs
   * @param {Object} data.<key>   - Form element ID
   * @param {Object} data.<value> - Form element value to be set
   */
  prepopulate: function(data) {
    var key, value;
    if (typeof data !== 'object') {
      return;
    }
    for (key in data) {
      value = data[key];
      if (!key.includes('#')) {
        key = '#' + key;
      }
      $(key).val(value).trigger('blur');
    }
  },
  reloadBindings: function($el, unbindFirst) {
    var $field, $fields, $inputEl, $label, field, gigFieldSelector, i, len, ref, results;
    if ($el == null) {
      $el = $(document.body);
    }
    if (unbindFirst == null) {
      unbindFirst = true;
    }
    gigFieldSelector = '.gig-field';
    $fields = $el.find(gigFieldSelector).addBack(gigFieldSelector);
    $fields.find('textarea').prevAll().addClass('label-textarea');
    results = [];
    for (i = 0, len = $fields.length; i < len; i++) {
      field = $fields[i];
      $field = $(field);
      $inputEl = $field.find('input, textarea');
      if ($inputEl.val()) {
        $field.addClass('filled');
        $label = $field.find('label');
      }
      if ($inputEl.prop('tagName').toUpperCase() === 'TEXTAREA' || (ref = $inputEl.attr('type'), indexOf.call(TEXT_INPUTS, ref) >= 0)) {
        $field.off('click', GIG.Forms.helpers.fieldClick);
        $inputEl.off('blur', GIG.Forms.helpers.inputBlur);
        $inputEl.off('focus', GIG.Forms.helpers.inputFocus);
        $field.on('click', GIG.Forms.helpers.fieldClick);
        $inputEl.on('blur', GIG.Forms.helpers.inputBlur);
        results.push($inputEl.on('focus', GIG.Forms.helpers.inputFocus));
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  removeError: function(field) {
    var $field, $label, $parent, isGIGField;
    $field = $(field);
    isGIGField = $field.hasClass('gig-field') || $field.hasClass('gig-field-dropdown');
    if (isGIGField) {
      $label = $field.find('label');
    } else {
      $parent = $field.parent();
      if ($parent.hasClass('gig-field') || $parent.hasClass('gig-field-dropdown')) {
        isGIGField = true;
        $field = $parent;
        $label = $parent.find('label');
      } else {
        $label = $field.siblings("label[for='" + ($field.attr('id')) + "']");
        if (!$label.length) {
          $label = $field.parents('label');
        }
      }
    }
    $label.find('.error-message').remove();
    $field.removeClass('error');
    if (isGIGField && !$field.hasClass('gig-field-dropdown')) {
      return GIG.Forms.helpers.fixLabel($label, $field);
    } else {
      return $label.removeClass('error');
    }
  },
  success: function(field) {
    var $field, $parent, isGIGField;
    $field = $(field);
    isGIGField = $field.hasClass('gig-field') || $field.hasClass('gig-field-dropdown');
    if (!isGIGField) {
      $parent = $field.parent();
      if ($parent.hasClass('gig-field') || $parent.hasClass('gig-field-dropdown')) {
        $field = $parent;
      }
    }
    GIG.Forms.removeError($field);
    return $field.addClass('success');
  }
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.Forms = Forms;


},{}],3:[function(require,module,exports){

/*
 * Determine browser specific animationend event name
 *
 * @returns {String|undefined} animations - Event name
 */
var Helper, whichAnimationEvent, whichTransitionEvent;

whichAnimationEvent = function() {
  var animations, el, t;
  el = document.createElement('fakeelement');
  animations = {
    'animation': 'animationend',
    'OAnimation': 'oAnimationEnd',
    'MozAnimation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd'
  };
  for (t in animations) {
    if (el.style[t] != null) {
      return animations[t];
    }
  }
  return void 0;
};


/*
 * Determine browser specific transitionend event name
 *
 * @returns {String|undefined} transitions - Event name
 */

whichTransitionEvent = function() {
  var el, t, transitions;
  el = document.createElement('fakeelement');
  transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  };
  for (t in transitions) {
    if (el.style[t] != null) {
      return transitions[t];
    }
  }
  return void 0;
};

Helper = {
  events: {
    animation: whichAnimationEvent(),
    transition: whichTransitionEvent()
  }
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.Helper = Helper;


},{}],4:[function(require,module,exports){
var boundTabEvent, init, truncateElements;

boundTabEvent = false;

truncateElements = require('./truncate-elements');

init = function(el) {
  $(document).ready(function() {
    var $el;
    if (navigator.userAgent.indexOf('MSIE 10') > -1) {
      $(document.documentElement).addClass('ie10');
    }
    if (el != null) {
      $el = $(el);
    }
    if ($el == null) {
      $el = $(document.body);
    }
    GIG.Forms.init($el);
    GIG.Modal.init($el);
    GIG.Tabs.init($el);
    GIG.Tooltip.init($el);
    $el.find('dl.accordion dt:not(.open)').addClass('closed');
    return $el.find('dl.accordion dt').click(function() {
      return $(this).toggleClass('open').toggleClass('closed');
    });
  });
  return $(window).on('load', function() {
    var $el;
    if (el != null) {
      $el = $(el);
    }
    if ($el == null) {
      $el = $(document.body);
    }
    truncateElements($el);
    if ($('.tab-content').length && !boundTabEvent) {
      $(document.body).on('tab-open', function(event, data) {
        var $tabContent;
        $tabContent = $('#' + data.id);
        if ($tabContent.is(":visible") && $tabContent.find(".should-truncate").length) {
          return truncateElements($tabContent);
        }
      });
      return boundTabEvent = true;
    }
  });
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.init = init;


},{"./truncate-elements":8}],5:[function(require,module,exports){
var Modal, callOnCloseCallbacks, closeOnBackgroundClick, onCloseCallbacks, onDataModalIdClick, randomModalId;

onCloseCallbacks = [];


/*
 * Close modal on clicking modal overlay
 *
 * @param {Object} e - Event
 */

closeOnBackgroundClick = function(e) {
  if (e.target === this) {
    if ($(this).data('closeonbgclick') !== false) {
      GIG.Modal.close(e);
    }
  }
};


/*
 * Generate random ID
 *
 * @returns {String} - Random ID
 */

randomModalId = function() {
  var time, value;
  time = new Date().getTime();
  value = Math.floor((Math.random() * 1000000000) + 1);
  return time + "-" + value;
};


/*
 * Execute modal closing callbacks
 *
 * @param {String} modalId - Modal ID
 */

callOnCloseCallbacks = function(modalId) {
  var adjust, cb, i, index, indexesToRemove, j, len, len1;
  indexesToRemove = [];
  for (index = i = 0, len = onCloseCallbacks.length; i < len; index = ++i) {
    cb = onCloseCallbacks[index];
    if (cb.modalId === null || cb.modalId === modalId) {
      cb.callback(modalId);
    }
    if (cb.once) {
      indexesToRemove.push(index);
    }
  }
  adjust = 0;
  for (j = 0, len1 = indexesToRemove.length; j < len1; j++) {
    index = indexesToRemove[j];
    onCloseCallbacks.splice(index - adjust, 1);
    adjust += 1;
  }
};


/*
 * Open modal on click
 *
 * @param {Object} e - Event
 */

onDataModalIdClick = function(e) {
  if (e != null) {
    e.preventDefault();
  }
  GIG.Modal.open({
    id: $(this).data('modal-id')
  });
};

Modal = {

  /*
   * Setup all modals present in the page
   * alternatively initialize modals from a passed DOM node
   * (e.g. for dynamically DOM nodes)
   *
   * @param {Object} [$body] - jQuery Object (optional)
   */
  init: function($body) {
    var $modal, error, scrollWindow;
    if (this.$body == null) {
      this.$body = $(document.body);
    }
    this.reloadBindings(this.$body, false);
    if (window.location.hash !== '') {
      try {
        $modal = $(".modal" + window.location.hash);
      } catch (error1) {
        error = error1;
        null;
      }
      if (($modal != null ? $modal.length : void 0) > 0) {
        this.open({
          el: $modal
        });
        scrollWindow = function() {
          window.scrollTo(0, 0);
        };
        setTimeout(scrollWindow, 10);
      }
    }
    this.$body.on('keyup.modal', (function(_this) {
      return function(e) {
        var ref;
        if (e.which !== 27) {
          return;
        }
        if (((ref = _this.currentOpenModal()) != null ? ref.data('closeonesckey') : void 0) !== false) {
          _this.close(e);
        }
      };
    })(this));
  },

  /*
   * Close modal and scroll to current window position
   *
   * @param {Object} [e] - Event (optional)
   */
  close: function(e) {
    var modalId, ref;
    if (e != null) {
      e.preventDefault();
    }
    if (this.$body == null) {
      this.$body = $(document.body);
    }
    modalId = (ref = GIG.Modal.currentOpenModal()) != null ? ref.attr('id') : void 0;
    $('.show-modal').removeClass('show-modal');
    $(document.body).removeClass('modal-open').css('top', '');
    if (this.scrollPos && this.scrollPos > 0) {
      window.scrollTo(0, this.scrollPos);
    }
    $('.close-modal').off('click', GIG.Modal.close);
    $('.modal').off('click', closeOnBackgroundClick);
    if (modalId != null) {
      return callOnCloseCallbacks(modalId);
    }
  },

  /*
   * Open modal and scroll to current window position
   *
   * @param {Object} options
   * @param {String} options.id - Modal ID
   * @param {String} options.el - DOM element
   */
  open: function(options) {
    var $el, id, modalEvent, ref;
    this.scrollPos = ((ref = document.documentElement) != null ? ref.scrollTop : void 0) || document.body.scrollTop;
    if (this.scrollPos < 0) {
      this.scrollPos = 0;
    }
    this.close();
    $el = options.el ? $(options.el) : $('#' + options.id);
    if ($el.parent()[0] !== document.body) {
      this.$body.append($el);
    }
    $el.addClass('show-modal');
    this.$body.css('top', -this.scrollPos).addClass('modal-open');
    $el.find('.close-modal').click((function(_this) {
      return function(e) {
        return _this.close(e);
      };
    })(this));
    $el.click(closeOnBackgroundClick);
    modalEvent = 'modal-open';
    id = (options != null ? options.id : void 0) || $el.attr('id');
    if (id != null) {
      this.$body.trigger(modalEvent, {
        id: id
      });
      this.$body.trigger(modalEvent + ":" + id);
    } else {
      this.$body.trigger(modalEvent);
    }
  },

  /*
   * Setup modal and bind events
   *
   * @param   {Object|String} modalHtml - Selector or jQuery Selector of the modal
   * @param   {Object}        [options] - Modal options
   * @returns {String}        id        - Modal ID
   */
  create: function(modalHtml, options) {
    var $modalHtml, $wrapper, id;
    if (options == null) {
      options = {};
    }
    $modalHtml = $(modalHtml);
    if (!$modalHtml.hasClass('modal')) {
      $wrapper = $('<div id="modal-' + randomModalId() + '" class="modal"><div class="modal-body"></div></div>');
      $wrapper.find('.modal-body').html($modalHtml);
      $modalHtml = $wrapper;
    } else if (!$modalHtml.attr('id')) {
      $modalHtml.attr('id', randomModalId());
    }
    if (options.closeOnBgClick != null) {
      $modalHtml.data('closeonbgclick', options.closeOnBgClick);
    }
    if (options.closeOnEscKey != null) {
      $modalHtml.data('closeonesckey', options.closeOnEscKey);
    }
    $(document.body).append($modalHtml);
    this.open({
      el: $modalHtml
    });
    id = $modalHtml.attr('id');
    if ((options.destroyOnClose == null) || options.destroyOnClose === true) {
      this.onClose(this.destroy, id, true);
    }
    if (typeof options.onClose === 'function') {
      this.onClose(options.onClose, id, true);
    }
    return id;
  },

  /*
   * Get open modal selector
   *
   * @returns {Object} - jQuery Selector of the current shown modal
   */
  currentOpenModal: function() {
    return $('.modal.show-modal');
  },

  /*
   * If no modalId is passed, it will try to destroy the modal that is open.
   *
   * @params {String} [modalID] - Modal ID (optional)
   */
  destroy: function(modalId) {
    var $modal;
    $modal = modalId != null ? $('#' + modalId) : GIG.Modal.currentOpenModal();
    if ((modalId == null) || $('#' + modalId + '.show-modal').length > 0) {
      GIG.Modal.close();
    }
    $modal.remove();
  },

  /*
   * Gather modal closing callback
   *
   * @params {Function} [callback] - Callback executed on close
   * @params {String}   [modalID]  - Modal ID (optional)
   * @params {Boolean}  [once]
   */
  onClose: function(callback, modalId, once) {
    if (modalId == null) {
      modalId = null;
    }
    if (once == null) {
      once = false;
    }
    onCloseCallbacks.push({
      callback: callback,
      modalId: modalId,
      once: once
    });
  },

  /*
   * Show the modal on clicking a modal trigger
   *
   * @params {Object}  [el]          - Element to look for modal triggers
   * @params {Boolean} [unbindFirst] - Remove modal event from triggers
   */
  reloadBindings: function(el, unbindFirst) {
    var $el, $elements;
    if (el == null) {
      el = document.body;
    }
    if (unbindFirst == null) {
      unbindFirst = true;
    }
    $el = $(el);
    $elements = $el.find('[data-modal-id]');
    if (unbindFirst) {
      $elements.off(onDataModalIdClick);
    }
    $elements.click(onDataModalIdClick);
  }
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.Modal = Modal;


},{}],6:[function(require,module,exports){
var Tabs;

Tabs = {
  init: function($body) {
    var $hashTabs, $tabContents, $tabs, activeTabs, error, i, j, k, l, len, len1, len2, len3, ref, ref1, results, selector, selectors, tabContent, tabContents, tabTrigger, tabs;
    if ($body == null) {
      $body = $(document.body);
    }
    this.reloadBindings($body, true);
    ref = $body.find('.tab-contents');
    for (i = 0, len = ref.length; i < len; i++) {
      tabContents = ref[i];
      $tabContents = $(tabContents);
      if (!$tabContents.children('.active').length) {
        $tabContents.children('.tab-content:first-child').addClass('active');
      }
    }
    ref1 = $body.find('.tabs, .pills');
    for (j = 0, len1 = ref1.length; j < len1; j++) {
      tabs = ref1[j];
      $tabs = $(tabs);
      if (!$tabs.children('.active').length) {
        $tabs.children('[data-tab-id]:first-child').addClass('active');
      }
    }
    this.helpers.activateTabContent('.tab-contents .active');
    activeTabs = $(this.helpers.tabTriggersSelector('.active'));
    for (k = 0, len2 = activeTabs.length; k < len2; k++) {
      tabTrigger = activeTabs[k];
      this.helpers.highlightTab(tabTrigger);
      this.helpers.activateTabContent('#' + $(tabTrigger).data('tab-id'));
    }
    if (window.location.hash !== '') {
      selectors = window.location.hash.slice(1).split(',');
      results = [];
      for (l = 0, len3 = selectors.length; l < len3; l++) {
        selector = selectors[l];
        if (selector !== '') {
          try {
            $hashTabs = $(this.helpers.tabTriggersSelector("[data-tab-id='" + selector + "']"));
            this.helpers.highlightTab($hashTabs);
            tabContent = '.tab-content#' + selector;
            this.helpers.activateTabContent(tabContent);
            results.push(this.helpers.openParentTabs(tabContent));
          } catch (error1) {
            error = error1;
            results.push(null);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    }
  },
  helpers: {
    tabTriggersSelector: function(selector) {
      if (selector == null) {
        selector = '[data-tab-id]';
      }
      return ".tabs " + selector + ", .pills " + selector;
    },
    activateTabContent: function(el) {
      var $adjacentTabs, $body, $newTabContent, id;
      if (el == null) {
        return false;
      }
      $newTabContent = $(el);
      id = $newTabContent.attr('id');
      $body = $(document.body);
      $newTabContent.addClass('active');
      $newTabContent.show();
      $body.trigger('tab-open', {
        id: id
      });
      $body.trigger("tab-open:" + id);
      $adjacentTabs = $newTabContent.siblings(".tab-content");
      $adjacentTabs.removeClass('active');
      return $adjacentTabs.hide();
    },
    highlightTab: function(el) {
      var $newTab;
      if (el == null) {
        return false;
      }
      $newTab = $(el);
      $newTab.addClass('active');
      return $newTab.siblings().removeClass('active');
    },
    openParentTabs: function(el) {
      var $thisTab, $unopenedParents, error, i, len, parent, results;
      if (el == null) {
        return false;
      }
      $thisTab = $(el);
      $unopenedParents = $thisTab.parents('.tab-content').not('.active');
      results = [];
      for (i = 0, len = $unopenedParents.length; i < len; i++) {
        parent = $unopenedParents[i];
        try {
          this.activateTabContent(parent);
          results.push(this.highlightTab(this.tabTriggersSelector("[data-tab-id='" + ($(parent).attr('id')) + "']")));
        } catch (error1) {
          error = error1;
          results.push(null);
        }
      }
      return results;
    },
    tab: function(e) {
      var $this, error, ref, selector, tabId;
      if (e != null) {
        e.preventDefault();
      }
      $this = $(this);
      tabId = $this.data('tab-id');
      if ((tabId == null) || $this.hasClass('active')) {
        return null;
      }
      selector = '#' + tabId;
      if ($this.data('push-state')) {
        if ((ref = window.history) != null) {
          if (typeof ref.pushState === "function") {
            ref.pushState(null, null, selector);
          }
        }
      }
      GIG.Tabs.helpers.highlightTab($this);
      try {
        GIG.Tabs.helpers.activateTabContent(selector);
        return GIG.Tabs.helpers.openParentTabs(selector);
      } catch (error1) {
        error = error1;
        return null;
      }
    }
  },
  reloadBindings: function(el, unbindFirst) {
    var $el, $elements;
    if (el == null) {
      el = document.body;
    }
    if (unbindFirst == null) {
      unbindFirst = true;
    }
    $el = $(el);
    $elements = $el.find(this.helpers.tabTriggersSelector());
    if (unbindFirst) {
      $elements.off('click', this.helpers.tab);
    }
    return $elements.on('click', this.helpers.tab);
  }
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.Tabs = Tabs;


},{}],7:[function(require,module,exports){
var POSITION_CLASSES, Tooltip, events,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

POSITION_CLASSES = ['.position-bottom', '.position-left', '.position-right', '.position-top'];

events = require('./helper');

Tooltip = {
  tooltips: {},
  openTooltips: [],
  isTrackingPosition: false,
  close: function(tooltip) {
    if (tooltip == null) {
      return null;
    }
    return GIG.Tooltip.helpers.hideTooltip.apply(tooltip);
  },
  helpers: {
    calculatePositioning: function(tooltip, target) {
      var $body, $target, $tooltip, bodyWidth, indicatorStyleOptions, offset, originalPositionType, positionType, potentialOffset, ref, targetHeight, targetWidth, tooltipHeight, tooltipStyleOptions, tooltipWidth;
      $target = $(target);
      $tooltip = $(tooltip);
      $body = $(document.body);
      bodyWidth = $body.width();
      targetHeight = $target.outerHeight();
      targetWidth = $target.outerWidth();
      tooltipHeight = $tooltip.outerHeight();
      tooltipWidth = $tooltip.outerWidth();
      offset = $target.offset();
      originalPositionType = (ref = $target.attr('data-position')) != null ? ref : $target.parent('.tooltip-trigger').attr('data-position');
      positionType = this.determinePositionType(originalPositionType, offset, $tooltip, $target, $body);
      tooltipStyleOptions = {
        display: 'block',
        left: 'auto',
        opacity: 1,
        right: 'auto'
      };
      switch (positionType) {
        case 'bottom':
          tooltipStyleOptions.top = offset.top + targetHeight - 16;
          break;
        case 'left':
          tooltipStyleOptions.left = offset.left - tooltipWidth;
          break;
        case 'right':
          tooltipStyleOptions.left = offset.left + targetWidth - 16;
          break;
        default:
          tooltipStyleOptions.top = offset.top - tooltipHeight;
      }
      if (positionType === 'left' || positionType === 'right') {
        tooltipStyleOptions.top = offset.top - (tooltipHeight / 2) + 10;
        indicatorStyleOptions = {
          left: '',
          right: '',
          top: (tooltipHeight / 2) - 8
        };
      } else {
        potentialOffset = offset.left - (tooltipWidth / 2) + (targetWidth / 2);
        if (potentialOffset <= 20) {
          tooltipStyleOptions.left = 20;
          indicatorStyleOptions = this.positionIndicator(true, offset, targetWidth, bodyWidth);
        } else if (potentialOffset + tooltipWidth >= bodyWidth - 20) {
          tooltipStyleOptions.right = 20;
          indicatorStyleOptions = this.positionIndicator(false, offset, targetWidth, bodyWidth);
        } else {
          tooltipStyleOptions.left = potentialOffset;
          indicatorStyleOptions = {
            left: (tooltipWidth / 2) - 8,
            top: ''
          };
        }
      }
      return {
        indicatorStyleOptions: indicatorStyleOptions,
        positionType: positionType,
        tooltipStyleOptions: tooltipStyleOptions
      };
    },
    cleanUpTooltip: function() {
      var $tooltip, ref, tooltipId;
      $tooltip = $(this);
      tooltipId = $tooltip.attr('id');
      if (events.transition) {
        $tooltip.off(events.transition);
      }
      $tooltip.css('display', 'none').removeClass("tooltip-open tooltip-click modal-tooltip " + (POSITION_CLASSES.join(' ').replace(/\./g, '')));
      return (ref = GIG.Tooltip.tooltips[tooltipId]) != null ? ref.shownOnTrigger = false : void 0;
    },
    determinePositionType: function(positionType, offset, tooltip, target, body) {
      var $body, $target, $tooltip;
      $tooltip = $(tooltip);
      $target = $(target);
      $body = $(body);
      if (positionType === 'left' || positionType === 'right') {
        if ($body.hasClass('rtl') || $body.attr('dir') === 'rtl') {
          if (positionType === 'left') {
            positionType = 'right';
          } else {
            positionType = 'left';
          }
        }
        if (positionType === 'left') {
          if (!(offset.left >= $tooltip.outerWidth() + 20)) {
            return 'top';
          }
        } else {
          if (!(offset.left + $target.outerWidth() + $tooltip.outerWidth() <= $body.outerWidth() - 20)) {
            return 'top';
          }
        }
        return positionType;
      } else {
        if (positionType === 'bottom' || positionType === 'top') {
          return positionType;
        }
        return 'top';
      }
    },
    hideTooltip: function() {
      var $this, $tooltip, openTooltips, ref, tooltipId;
      $this = $(this);
      if ($this.hasClass('tooltip-trigger')) {
        tooltipId = $this.attr('data-tooltip-id');
        $tooltip = $('#' + tooltipId);
      } else if ($this.hasClass('tooltip-close')) {
        $tooltip = $this.parents('.tooltip');
        tooltipId = $tooltip.attr('id');
      } else {
        tooltipId = $this.attr('id');
        $tooltip = $this;
      }
      if (((ref = GIG.Tooltip.tooltips[tooltipId]) != null ? ref.animate : void 0) && events.transition) {
        $tooltip.on(events.transition, GIG.Tooltip.helpers.cleanUpTooltip);
      } else {
        GIG.Tooltip.helpers.cleanUpTooltip.apply($tooltip);
      }
      $tooltip.css({
        opacity: 0
      });
      openTooltips = GIG.Tooltip.openTooltips;
      GIG.Tooltip.openTooltips = openTooltips.filter(function(el) {
        return el !== $tooltip[0].id;
      });
    },
    positionIndicator: function(left, offset, targetWidth, bodyWidth) {
      var offsetBy;
      if (left) {
        offsetBy = {
          left: offset.left + (targetWidth / 2) - 26,
          right: '',
          top: ''
        };
      } else {
        offsetBy = {
          left: '',
          right: bodyWidth - (offset.left + (targetWidth / 2)) - 26,
          top: ''
        };
      }
      return offsetBy;
    },
    reShowTooltip: function() {
      var $this, $tooltip;
      $this = $(this);
      if ($this.hasClass('tooltip-trigger')) {
        $tooltip = $('#' + $this.attr('data-tooltip-id'));
      } else {
        $tooltip = $this;
      }
      if (events.transition) {
        $tooltip.off(events.transition);
      }
      return $tooltip.css('opacity', 1);
    },
    tooltip: function(e) {
      var $trigger, ref, tooltipId;
      $trigger = $(this);
      tooltipId = $trigger.attr('data-tooltip-id');
      if (((ref = GIG.Tooltip.tooltips[tooltipId]) != null ? ref.shownOnTrigger : void 0) === $trigger[0]) {
        GIG.Tooltip.helpers.reShowTooltip.apply($trigger);
        return;
      }
      if (e != null) {
        e.preventDefault();
      }
      return GIG.Tooltip.open('#' + tooltipId, $trigger, e != null ? e.type : void 0);
    },
    unbindSpecialTriggers: function(elements) {
      var $el, el, j, len, results, trigger;
      if (elements == null) {
        elements = [];
      }
      results = [];
      for (j = 0, len = elements.length; j < len; j++) {
        el = elements[j];
        $el = $(el);
        trigger = $el.attr('data-trigger-event');
        $el.off(trigger, GIG.Tooltip.helpers.tooltip);
        results.push($el.off('mouseover', GIG.Tooltip.helpers.tooltip));
      }
      return results;
    }
  },
  init: function($body) {
    if ($body == null) {
      $body = $(document.body);
    }
    this.reloadBindings($body, true);
    return $body.on('modal-open', function() {
      var $positionedTooltips;
      $positionedTooltips = $('.tooltip').filter(POSITION_CLASSES.join(', '));
      return $.each($positionedTooltips, function(i, tooltip) {
        return GIG.Tooltip.close(tooltip);
      });
    });
  },
  open: function(tooltip, trigger, eventType) {
    var $target, $tooltip, $trigger, base, getPositionData, positionInfo, postAnimation, ref, tooltipClasses, tooltipId, tooltipInfo;
    $tooltip = $(tooltip);
    tooltipId = $tooltip.attr('id');
    if ($tooltip.parent()[0] !== document.body) {
      $(document.body).append($tooltip);
    }
    $trigger = $($(trigger)[0]);
    $target = $trigger.find('.tooltip-target');
    if (!$target.length) {
      $target = $trigger;
    }
    if ((base = GIG.Tooltip.tooltips)[tooltipId] == null) {
      base[tooltipId] = {};
    }
    tooltipInfo = GIG.Tooltip.tooltips[tooltipId];
    if (tooltipInfo != null) {
      tooltipInfo.shownOnTrigger = $trigger[0];
    }
    if (tooltipInfo != null) {
      tooltipInfo.animate = !$trigger.attr('data-dont-animate');
    }
    getPositionData = function() {
      var positionInfo, tooltipClasses;
      positionInfo = GIG.Tooltip.helpers.calculatePositioning($tooltip, $target);
      tooltipClasses = "position-" + positionInfo.positionType;
      if (eventType !== 'mouseover') {
        tooltipClasses += ' tooltip-click';
      }
      if ($target.parents('.modal').length) {
        tooltipClasses += ' modal-tooltip';
      }
      if (!tooltipInfo.animate) {
        positionInfo['animation-duration'] = '0ms';
        positionInfo['transition-duration'] = '0ms';
      } else {
        positionInfo['animation-duration'] = '';
        positionInfo['transition-duration'] = '';
      }
      return {
        positionInfo: positionInfo,
        tooltipClasses: tooltipClasses
      };
    };
    postAnimation = function() {
      var $closers, $tooltipAndTrigger;
      $tooltip.addClass('tooltip-open');
      if (eventType === 'mouseover') {
        $tooltipAndTrigger = $tooltip.add($trigger);
        $tooltipAndTrigger.off('mouseleave');
        $tooltipAndTrigger.on('mouseleave', GIG.Tooltip.helpers.hideTooltip);
      } else if (!($tooltip.children('.tooltip-close').length > 0)) {
        $tooltip.append('<a class="tooltip-close icon-x"></a>');
      }
      $closers = $tooltip.children('.tooltip-close');
      $closers.off('click');
      return $closers.on('click', GIG.Tooltip.helpers.hideTooltip);
    };
    if (!tooltipInfo.boundMouseOver) {
      $tooltip.on('mouseover', GIG.Tooltip.helpers.reShowTooltip);
      tooltipInfo.boundMouseOver = true;
    }
    if (events.animation) {
      $tooltip.one(events.animation, postAnimation);
    } else {
      postAnimation();
    }
    ref = getPositionData(), positionInfo = ref.positionInfo, tooltipClasses = ref.tooltipClasses;
    $tooltip.css(positionInfo.tooltipStyleOptions).removeClass(POSITION_CLASSES.join(' ').replace(/\./g, '')).addClass(tooltipClasses);
    $tooltip.find(".indicator").css(positionInfo.indicatorStyleOptions);
    GIG.Tooltip.openTooltips.push($tooltip[0].id);
  },

  /*
   * Iterate over open tooltips and refresh their position
   */
  refresh: function() {
    var $triggers;
    $triggers = $('.tooltip-trigger[data-tooltip-id]');
    GIG.Tooltip.openTooltips.forEach(function(el) {
      var $target, $tooltip, tooltipStyleOptions;
      $target = $triggers.filter(function() {
        return $(this).data().tooltipId === el;
      });
      $tooltip = $('#' + el);
      tooltipStyleOptions = GIG.Tooltip.helpers.calculatePositioning($tooltip, $target).tooltipStyleOptions;
      return $tooltip.css(tooltipStyleOptions);
    });
  },
  reloadBindings: function(el, unbindFirst) {
    var $elements, $normalTriggers, $specialTriggers, orientationEvent, touchSupported;
    if (el == null) {
      el = document.body;
    }
    if (unbindFirst == null) {
      unbindFirst = true;
    }
    $elements = $(el).find('.tooltip-trigger');
    touchSupported = typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.touch : void 0;
    if (touchSupported) {
      $elements.filter(':not([data-trigger-event])').attr('data-trigger-event', 'click mouseover');
    }
    $specialTriggers = $elements.filter('[data-trigger-event]');
    $normalTriggers = $elements.not($specialTriggers);
    if (unbindFirst) {
      $normalTriggers.off('mouseover', this.helpers.tooltip);
      this.helpers.unbindSpecialTriggers($specialTriggers);
    }
    $normalTriggers.on('mouseover', this.helpers.tooltip);

    /*
     * Set up resizing / orientationchange event to recalculate open tooltips position
     */
    if (!GIG.Tooltip.isTrackingPosition && $elements.length) {
      orientationEvent = indexOf.call(window, "onorientationchange") >= 0 ? "orientationchange" : "resize";
      window.addEventListener(orientationEvent, function() {
        _.debounce(GIG.Tooltip.refresh(), 50);
      }, false);
      GIG.Tooltip.isTrackingPosition = true;
    }
    return $.each($specialTriggers, function(i, trigger) {
      var $trigger, e;
      $trigger = $(trigger);
      if ($trigger.find('.tooltip-trigger').length) {
        return;
      }
      if (touchSupported && !($trigger.hasClass('icon-question') || $trigger.hasClass('icon-info'))) {
        if (!$trigger.find('.tooltip-target').length) {
          $trigger.append("&nbsp;<span class='tooltip-target icon-question'></div>");
        }
      }
      try {
        return $trigger.on($trigger.attr('data-trigger-event') || 'click mouseover', GIG.Tooltip.helpers.tooltip);
      } catch (error) {
        e = error;
        return $trigger.on('mouseover', GIG.Tooltip.helpers.tooltip);
      }
    });
  }
};

if (window.GIG == null) {
  window.GIG = {};
}

module.exports = GIG.Tooltip = Tooltip;


},{"./helper":3}],8:[function(require,module,exports){
var base, isBoolean, truncateElements;

isBoolean = function(value) {
  return typeof value === "boolean";
};

truncateElements = function(el, options) {
  var $truncateElements, element, i, len, results, truncateThis;
  if (el == null) {
    el = document.body;
  }
  if (options == null) {
    options = {};
  }
  $truncateElements = $(el).find('.should-truncate');
  if (!($truncateElements.length > 0)) {
    return;
  }
  options = {
    ellipsis: options.ellipsis || '... ',
    wrap: options.wrap || 'word',
    fallbackToLetter: isBoolean(options.fallbackToLetter) ? options.fallbackToLetter : true,
    watch: isBoolean(options.watch) ? options.watch : false,
    tolerance: options.tolerance || 0
  };
  truncateThis = function(element) {
    return setTimeout((function() {
      return $(element).dotdotdot(options);
    }), 0);
  };
  results = [];
  for (i = 0, len = $truncateElements.length; i < len; i++) {
    element = $truncateElements[i];
    results.push(truncateThis(element));
  }
  return results;
};

if (window.GIG == null) {
  window.GIG = {};
}

if ((base = window.GIG).Utils == null) {
  base.Utils = {};
}

window.GIG.Utils.truncateElements = truncateElements;

module.exports = truncateElements;


},{}],9:[function(require,module,exports){
var gigForms, gigHelper, gigInit, gigModal, gigTabs, gigTooltip, truncateElements;

if (window.GIG == null) {
  window.GIG = {};
}

require('./vendor_modules/jquery.dotdotdot');

gigInit = require('./coffee/init.coffee');

gigHelper = require('./coffee/helper.coffee');

gigForms = require('./coffee/forms.coffee');

gigModal = require('./coffee/modal.coffee');

gigTabs = require('./coffee/tabs.coffee');

gigTooltip = require('./coffee/tooltip.coffee');

truncateElements = require('./coffee/truncate-elements.coffee');

window.GIG = _.extend({}, GIG, {
  init: gigInit,
  Helper: gigHelper,
  Forms: gigForms,
  Modal: gigModal,
  Tabs: gigTabs,
  Tooltip: gigTooltip,
  Utils: {
    truncateElements: truncateElements
  }
});

gigInit();

module.exports = GIG;


},{"./coffee/forms.coffee":2,"./coffee/helper.coffee":3,"./coffee/init.coffee":4,"./coffee/modal.coffee":5,"./coffee/tabs.coffee":6,"./coffee/tooltip.coffee":7,"./coffee/truncate-elements.coffee":8,"./vendor_modules/jquery.dotdotdot":10}],10:[function(require,module,exports){
/*
 *	jQuery dotdotdot 1.6.16
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */

(function( $, undef )
{
	if ( $.fn.dotdotdot )
	{
		return;
	}

	$.fn.dotdotdot = function( o )
	{
		if ( this.length == 0 )
		{
			$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
			return this;
		}
		if ( this.length > 1 )
		{
			return this.each(
				function()
				{
					$(this).dotdotdot( o );
				}
			);
		}


		var $dot = this;

		if ( $dot.data( 'dotdotdot' ) )
		{
			$dot.trigger( 'destroy.dot' );
		}

		$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
		$dot.css( 'word-wrap', 'break-word' );
		if ($dot.css( 'white-space' ) === 'nowrap')
		{
			$dot.css( 'white-space', 'normal' );
		}

		$dot.bind_events = function()
		{
			$dot.bind(
				'update.dot',
				function( e, c )
				{
					e.preventDefault();
					e.stopPropagation();

					opts.maxHeight = ( typeof opts.height == 'number' )
						? opts.height
						: getTrueInnerHeight( $dot );

					opts.maxHeight += opts.tolerance;

					if ( typeof c != 'undefined' )
					{
						if ( typeof c == 'string' || c instanceof HTMLElement )
						{
					 		c = $('<div />').append( c ).contents();
						}
						if ( c instanceof $ )
						{
							orgContent = c;
						}
					}

					$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
					$inr.contents()
						.detach()
						.end()
						.append( orgContent.clone( true ) )
						.find( 'br' )
						.replaceWith( '  <br />  ' )
						.end()
						.css({
							'height'	: 'auto',
							'width'		: 'auto',
							'border'	: 'none',
							'padding'	: 0,
							'margin'	: 0
						});

					var after = false,
						trunc = false;

					if ( conf.afterElement )
					{
						after = conf.afterElement.clone( true );
					    after.show();
						conf.afterElement.detach();
					}

					if ( test( $inr, opts ) )
					{
						if ( opts.wrap == 'children' )
						{
							trunc = children( $inr, opts, after );
						}
						else
						{
							trunc = ellipsis( $inr, $dot, $inr, opts, after );
						}
					}
					$inr.replaceWith( $inr.contents() );
					$inr = null;

					if ( $.isFunction( opts.callback ) )
					{
						opts.callback.call( $dot[ 0 ], trunc, orgContent );
					}

					conf.isTruncated = trunc;
					return trunc;
				}

			).bind(
				'isTruncated.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], conf.isTruncated );
					}
					return conf.isTruncated;
				}

			).bind(
				'originalContent.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], orgContent );
					}
					return orgContent;
				}

			).bind(
				'destroy.dot',
				function( e )
				{
					e.preventDefault();
					e.stopPropagation();

					$dot.unwatch()
						.unbind_events()
						.contents()
						.detach()
						.end()
						.append( orgContent )
						.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
						.data( 'dotdotdot', false );
				}
			);
			return $dot;
		};	//	/bind_events

		$dot.unbind_events = function()
		{
			$dot.unbind('.dot');
			return $dot;
		};	//	/unbind_events

		$dot.watch = function()
		{
			$dot.unwatch();
			if ( opts.watch == 'window' )
			{
				var $window = $(window),
					_wWidth = $window.width(),
					_wHeight = $window.height();

				$window.bind(
					'resize.dot' + conf.dotId,
					function()
					{
						if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
						{
							_wWidth = $window.width();
							_wHeight = $window.height();

							if ( watchInt )
							{
								clearInterval( watchInt );
							}
							watchInt = setTimeout(
								function()
								{
									$dot.trigger( 'update.dot' );
								}, 100
							);
						}
					}
				);
			}
			else
			{
				watchOrg = getSizes( $dot );
				watchInt = setInterval(
					function()
					{
						if ( $dot.is( ':visible' ) )
						{
							var watchNew = getSizes( $dot );
							if ( watchOrg.width  != watchNew.width ||
								 watchOrg.height != watchNew.height )
							{
								$dot.trigger( 'update.dot' );
								watchOrg = watchNew;
							}
						}
					}, 500
				);
			}
			return $dot;
		};
		$dot.unwatch = function()
		{
			$(window).unbind( 'resize.dot' + conf.dotId );
			if ( watchInt )
			{
				clearInterval( watchInt );
			}
			return $dot;
		};

		var	orgContent	= $dot.contents(),
			opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
			conf		= {},
			watchOrg	= {},
			watchInt	= null,
			$inr		= null;


		if ( !( opts.lastCharacter.remove instanceof Array ) )
		{
			opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
		}
		if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
		{
			opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
		}


		conf.afterElement	= getElement( opts.after, $dot );
		conf.isTruncated	= false;
		conf.dotId			= dotId++;


		$dot.data( 'dotdotdot', true )
			.bind_events()
			.trigger( 'update.dot' );

		if ( opts.watch )
		{
			$dot.watch();
		}

		return $dot;
	};


	//	public
	$.fn.dotdotdot.defaults = {
		'ellipsis'			: '... ',
		'wrap'				: 'word',
		'fallbackToLetter'	: true,
		'lastCharacter'		: {},
		'tolerance'			: 0,
		'callback'			: null,
		'after'				: null,
		'height'			: null,
		'watch'				: false,
		'windowResizeFix'	: true
	};
	$.fn.dotdotdot.defaultArrays = {
		'lastCharacter'		: {
			'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
			'noEllipsis'		: []
		}
	};
	$.fn.dotdotdot.debug = function( msg ) {};


	//	private
	var dotId = 1;

	function children( $elem, o, after )
	{
		var $elements 	= $elem.children(),
			isTruncated	= false;

		$elem.empty();

		for ( var a = 0, l = $elements.length; a < l; a++ )
		{
			var $e = $elements.eq( a );
			$elem.append( $e );
			if ( after )
			{
				$elem.append( after );
			}
			if ( test( $elem, o ) )
			{
				$e.remove();
				isTruncated = true;
				break;
			}
			else
			{
				if ( after )
				{
					after.detach();
				}
			}
		}
		return isTruncated;
	}
	function ellipsis( $elem, $d, $i, o, after )
	{
		var isTruncated	= false;

		//	Don't put the ellipsis directly inside these elements
		var notx = 'table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';

		//	Don't remove these elements even if they are after the ellipsis
		var noty = 'script, .dotdotdot-keep';

		$elem
			.contents()
			.detach()
			.each(
				function()
				{

					var e	= this,
						$e	= $(e);

					if ( typeof e == 'undefined' || ( e.nodeType == 3 && $.trim( e.data ).length == 0 ) )
					{
						return true;
					}
					else if ( $e.is( noty ) )
					{
						$elem.append( $e );
					}
					else if ( isTruncated )
					{
						return true;
					}
					else
					{
						$elem.append( $e );
						if ( after )
						{
							$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
						}
						if ( test( $i, o ) )
						{
							if ( e.nodeType == 3 ) // node is TEXT
							{
								isTruncated = ellipsisElement( $e, $d, $i, o, after );
							}
							else
							{
								isTruncated = ellipsis( $e, $d, $i, o, after );
							}

							if ( !isTruncated )
							{
								$e.detach();
								isTruncated = true;
							}
						}

						if ( !isTruncated )
						{
							if ( after )
							{
								after.detach();
							}
						}
					}
				}
			);

		return isTruncated;
	}
	function ellipsisElement( $e, $d, $i, o, after )
	{
		var e = $e[ 0 ];

		if ( !e )
		{
			return false;
		}

		var txt			= getTextContent( e ),
			space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
			separator	= ( o.wrap == 'letter' ) ? '' : space,
			textArr		= txt.split( separator ),
			position 	= -1,
			midPos		= -1,
			startPos	= 0,
			endPos		= textArr.length - 1;


		//	Only one word
		if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
		{
			separator	= '';
			textArr		= txt.split( separator );
			endPos		= textArr.length - 1;
		}

		while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
		{
			var m = Math.floor( ( startPos + endPos ) / 2 );
			if ( m == midPos )
			{
				break;
			}
			midPos = m;

			setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );

			if ( !test( $i, o ) )
			{
				position = midPos;
				startPos = midPos;
			}
			else
			{
				endPos = midPos;

				//	Fallback to letter
				if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
				{
					separator	= '';
					textArr		= textArr[ 0 ].split( separator );
					position	= -1;
					midPos		= -1;
					startPos	= 0;
					endPos		= textArr.length - 1;
				}
			}
		}

		if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
		{
			txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
			setTextContent( e, txt );
		}
		else
		{
			var $w = $e.parent();
			$e.detach();

			var afterLength = ( after && after.closest($w).length ) ? after.length : 0;

			if ( $w.contents().length > afterLength )
			{
				e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
			}
			else
			{
				e = findLastTextNode( $w, $d, true );
				if ( !afterLength )
				{
					$w.detach();
				}
			}
			if ( e )
			{
				txt = addEllipsis( getTextContent( e ), o );
				setTextContent( e, txt );
				if ( afterLength && after )
				{
					$(e).parent().append( after );
				}
			}
		}

		return true;
	}
	function test( $i, o )
	{
		return $i.innerHeight() > o.maxHeight;
	}
	function addEllipsis( txt, o )
	{
		while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
		{
			txt = txt.slice( 0, -1 );
		}
		if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
		{
			txt += o.ellipsis;
		}
		return txt;
	}
	function getSizes( $d )
	{
		return {
			'width'	: $d.innerWidth(),
			'height': $d.innerHeight()
		};
	}
	function setTextContent( e, content )
	{
		if ( e.innerText )
		{
			e.innerText = content;
		}
		else if ( e.nodeValue )
		{
			e.nodeValue = content;
		}
		else if (e.textContent)
		{
			e.textContent = content;
		}

	}
	function getTextContent( e )
	{
		if ( e.innerText )
		{
			return e.innerText;
		}
		else if ( e.nodeValue )
		{
			return e.nodeValue;
		}
		else if ( e.textContent )
		{
			return e.textContent;
		}
		else
		{
			return "";
		}
	}
	function getPrevNode( n )
	{
		do
		{
			n = n.previousSibling;
		}
		while ( n && n.nodeType !== 1 && n.nodeType !== 3 );

		return n;
	}
	function findLastTextNode( $el, $top, excludeCurrent )
	{
		var e = $el && $el[ 0 ], p;
		if ( e )
		{
			if ( !excludeCurrent )
			{
				if ( e.nodeType === 3 )
				{
					return e;
				}
				if ( $.trim( $el.text() ) )
				{
					return findLastTextNode( $el.contents().last(), $top );
				}
			}
			p = getPrevNode( e );
			while ( !p )
			{
				$el = $el.parent();
				if ( $el.is( $top ) || !$el.length )
				{
					return false;
				}
				p = getPrevNode( $el[0] );
			}
			if ( p )
			{
				return findLastTextNode( $(p), $top );
			}
		}
		return false;
	}
	function getElement( e, $i )
	{
		if ( !e )
		{
			return false;
		}
		if ( typeof e === 'string' )
		{
			e = $(e, $i);
			return ( e.length )
				? e
				: false;
		}
		return !e.jquery
			? false
			: e;
	}
	function getTrueInnerHeight( $el )
	{
		var h = $el.innerHeight(),
			a = [ 'paddingTop', 'paddingBottom' ];

		for ( var z = 0, l = a.length; z < l; z++ )
		{
			var m = parseInt( $el.css( a[ z ] ), 10 );
			if ( isNaN( m ) )
			{
				m = 0;
			}
			h -= m;
		}
		return h;
	}


	//	override jQuery.html
	var _orgHtml = $.fn.html;
	$.fn.html = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			return this.trigger( 'update', [ str ] );
		}
		return _orgHtml.apply( this, arguments );
	};


	//	override jQuery.text
	var _orgText = $.fn.text;
	$.fn.text = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			str = $( '<div />' ).text( str ).html();
			return this.trigger( 'update', [ str ] );
		}
		return _orgText.apply( this, arguments );
	};


})( jQuery );

},{}]},{},[1])

